// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { IconButton } from '@gandi/ui';

type Props = {
  addedToCart?: boolean,
  optimistic?: boolean,
  isCartActionnable?: boolean,
  onClick: (evt: SyntheticMouseEvent<>) => Promise<void>,
};

function getKind({
  addedToCart,
  optimistic,
}: {
  addedToCart?: boolean,
  optimistic?: boolean,
}): 'ghost' | 'outline' | void {
  if (optimistic) return 'ghost';
  if (addedToCart) return undefined;
  return 'outline';
}

function CartButton({
  addedToCart,
  isCartActionnable,
  onClick,
  optimistic,
}: Props) {
  const { __ } = useTranslator();

  return (
    <IconButton
      onClick={isCartActionnable ? onClick : undefined}
      disabled={!isCartActionnable}
      kind={getKind({ addedToCart, optimistic })}
      icon={addedToCart && !optimistic ? 'checkmark' : 'cart'}
      intent={addedToCart && !optimistic ? 'success' : undefined}
      loading={optimistic}
    >
      {addedToCart ? __('Remove from cart') : __('Add to cart')}
    </IconButton>
  );
}

export default (React.memo<Props>(CartButton): React.ComponentType<Props>);
